import { defineMessages } from 'react-intl';

export const ratingPageHeadMessages = defineMessages({
  title: {
    defaultMessage: 'Kundenbewertungen',
    id: 'customer-ratings.seo.title',
  },
});
